module.exports = __webpack_public_path__ + "static/media/tire-purchase-logo.c6173411.svg";